"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeScriptAction = executeScriptAction;
/**
 * Executes a script based on the provided script name.
 *
 * @param {string} scriptName The name of the script to execute.
 * @returns {void}
 */
function executeScriptAction(scriptName) {
  if (typeof window === 'undefined') {
    return;
  }
  const scriptFunctions = {
    showConsentManager: () => window.ux.privacy.showManager(),
    // eslint-disable-next-line no-alert
    showAlertModal: () => alert('This is an alert modal')
    // Add more mappings as needed
  };
  const scriptFunction = scriptFunctions[scriptName];
  if (scriptFunction) {
    scriptFunction();
  } else {
    // eslint-disable-next-line no-console
    console.warn(`No script found for action: ${scriptName}`);
  }
}